export default __webpack_public_path__ + "static/media/pelo.8406c0a4.png";